import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'Utils/constants';
import logoWhiteImage from 'assets/logo-white.png';
import mockupDashboardsImage from 'assets/mockup-dashboards.png';
import bgAuthImage from 'assets/bg-auth.webp';

export default function AuthLayoutDecoration() {
    const { t } = useTranslation('auth');

    return (
        <div
            className="hidden min-[1200px]:block self-stretch justify-self-stretch bg-[#17053F] bg-cover bg-center bg-no-repeat text-white"
            style={{ backgroundImage: `url(${bgAuthImage})` }}
        >
            <div className="sticky top-0 flex h-dvh flex-col overflow-hidden pl-10">
                <div className="flex min-h-[50vh] flex-col justify-between gap-8 pt-[6vh] pb-[3vh] pl-1">
                    <Link to={ROUTES.landing}>
                        <img src={logoWhiteImage} alt="Banktrack" className="block h-auto w-[42%] min-w-[164px]" />
                    </Link>
                    <figure className="max-w-[300px] pb-4">
                        <svg
                            width="34"
                            height="25"
                            viewBox="0 0 34 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            className="mb-5"
                        >
                            <path
                                d="M7.29183 24.243C5.27158 24.243 3.53543 23.5485 2.08338 22.1596C0.694464 20.7707 0 19.0661 0 17.0458C0 15.9095 0.220965 14.8362 0.662894 13.8261C1.10482 12.8159 1.76771 11.648 2.65157 10.3222L9.65933 0L14.3942 3.12507L9.65933 10.4169C10.9851 10.7957 12.1215 11.5849 13.0684 12.7844C14.0154 13.9839 14.4889 15.4044 14.4889 17.0458C14.4889 19.003 13.7945 20.7075 12.4056 22.1596C11.0166 23.5485 9.31208 24.243 7.29183 24.243ZM25.8528 24.243C23.8326 24.243 22.0964 23.5485 20.6444 22.1596C19.2555 20.7707 18.561 19.0661 18.561 17.0458C18.561 15.9095 18.782 14.8362 19.2239 13.8261C19.6658 12.8159 20.3287 11.648 21.2126 10.3222L28.2203 0L32.9553 3.12507L28.2203 10.4169C29.5461 10.7957 30.6825 11.5849 31.6295 12.7844C32.5765 13.9839 33.05 15.4044 33.05 17.0458C33.05 19.003 32.3555 20.7075 30.9666 22.1596C29.5777 23.5485 27.8731 24.243 25.8528 24.243Z"
                                fill="white"
                            />
                        </svg>
                        <blockquote className="text-[32px] font-bold leading-[1.1] tracking-tight">
                            {t('testimonial-quote')}
                        </blockquote>
                        <figcaption className="mt-4 text-base text-white/80">
                            <div className="font-bold">{t('testimonial-author-name')}</div>
                            <div className="opacity-50">{t('testimonial-author-role')}</div>
                        </figcaption>
                    </figure>
                </div>

                <div className="relative flex-1 after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-1/5 after:bg-[linear-gradient(-90deg,rgba(0,0,0,0.05)_0%,rgba(0,0,0,0)_100%)] after:mix-blend-multiply after:content-['']">
                    <img
                        src={mockupDashboardsImage}
                        alt=""
                        className="block h-full w-full object-cover object-left-top"
                    />
                </div>
            </div>
        </div>
    );
}
